import { render, staticRenderFns } from "./OurServicesGrid.vue?vue&type=template&id=430a19fe&scoped=true"
import script from "./OurServicesGrid.vue?vue&type=script&lang=js"
export * from "./OurServicesGrid.vue?vue&type=script&lang=js"
import style0 from "./OurServicesGrid.vue?vue&type=style&index=0&id=430a19fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430a19fe",
  null
  
)

export default component.exports